import { Helmet } from "react-helmet-async";

const Admissions2026 = () => {
  return (
    <div className="bg-white text-gray-800">
      <Helmet>
        <title>Admission Open 2025-26 | SSS Achievers Coaching Ghazipur</title>
        <meta name="description" content="Admissions open at SSS Achievers, Ghazipur's best coaching center for Class 8-12. Limited seats for 2025-26 batch. CBSE board prep, expert faculty, affordable fees. Enroll now!" />
        <link rel="canonical" href="https://www.sssachievers.com/admission-open" />
        <meta property="og:title" content="Admission Open 2025-26 | SSS Achievers Ghazipur" />
        <meta property="og:url" content="https://www.sssachievers.com/admission-open" />
      </Helmet>

      {/* Hero Section */}
      <section className="py-20" style={{ backgroundColor: "#2190b8" }}>
        <div className="max-w-7xl mx-auto px-6 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Admissions Open 2026
          </h1>
          <p className="text-xl mb-6">
            Class 8th to 12th • SSS Achievers
          </p>
          <p className="max-w-3xl mx-auto text-lg opacity-90">
            Strong foundation, smart learning, and result-oriented preparation
            for academic excellence.
          </p>

          <div className="mt-8">
            <a
              href="tel:+919918519991"
              className="inline-block px-8 py-3 rounded-xl font-semibold text-black transition"
              style={{ backgroundColor: "#fcbf0a" }}
            >
              Call for Admission: +91 99185 19991
            </a>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2
            className="text-3xl font-bold mb-6"
            style={{ color: "#2190b8" }}
          >
            About SSS Achievers
          </h2>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto">
            SSS Achievers is a trusted academic institute focused on strong
            concepts, disciplined learning, and consistent performance growth
            from Class 8th to 12th.
          </p>
        </div>
      </section>

      {/* Courses Offered */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2
            className="text-3xl font-bold text-center mb-12"
            style={{ color: "#2190b8" }}
          >
            Courses Offered – 2026
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                title: "Class 8th – Foundation",
                points: [
                  "Strong basics in Maths & Science",
                  "Concept clarity with regular practice",
                  "School exam preparation",
                ],
              },
              {
                title: "Class 9th & 10th",
                points: [
                  "Board-focused syllabus",
                  "Weekly tests & doubt sessions",
                  "Individual performance tracking",
                ],
              },
              {
                title: "Class 11th & 12th",
                points: [
                  "Advanced concept training",
                  "Board + competitive foundation",
                  "Result-driven teaching approach",
                ],
              },
            ].map((course, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-2xl shadow-md"
              >
                <h3
                  className="text-xl font-semibold mb-4"
                  style={{ color: "#2190b8" }}
                >
                  {course.title}
                </h3>
                <ul className="space-y-2 text-gray-600">
                  {course.points.map((point, i) => (
                    <li key={i}>• {point}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6">
          <h2
            className="text-3xl font-bold text-center mb-12"
            style={{ color: "#2190b8" }}
          >
            Why Choose SSS Achievers
          </h2>

          <div className="grid md:grid-cols-2 gap-8 text-lg text-gray-600">
            <ul className="space-y-3">
              <li>✔ Experienced & dedicated faculty</li>
              <li>✔ AI Smart Board based teaching</li>
              <li>✔ Small & focused batches</li>
              <li>✔ Regular tests & analysis</li>
            </ul>
            <ul className="space-y-3">
              <li>✔ Doubt-clearing sessions</li>
              <li>✔ Student-friendly environment</li>
              <li>✔ Parent-teacher interaction</li>
              <li>✔ Consistent results every year</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Teaching Methodology */}
      <section className="py-16" style={{ backgroundColor: "#e9f6fb" }}>
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2
            className="text-3xl font-bold mb-6"
            style={{ color: "#2190b8" }}
          >
            Smart Learning with AI Technology
          </h2>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto">
            Our AI Smart Board classrooms make learning interactive, visual,
            and engaging—helping students understand faster and perform better.
          </p>
        </div>
      </section>

      {/* Admission Process */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <h2
            className="text-3xl font-bold text-center mb-10"
            style={{ color: "#2190b8" }}
          >
            Admission Process – 2026
          </h2>

          <div className="grid md:grid-cols-3 gap-8 text-center">
            {[
              "Call or visit the center",
              "Counselling & assessment",
              "Confirm admission & batch",
            ].map((step, index) => (
              <div
                key={index}
                className="bg-gray-50 p-6 rounded-xl shadow-sm"
              >
                <h3
                  className="text-xl font-semibold mb-3"
                  style={{ color: "#2190b8" }}
                >
                  Step {index + 1}
                </h3>
                <p className="text-gray-600">{step}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

    

    </div>
  );
};

export default Admissions2026;
